import styled from 'styled-components';
import { shade } from 'polished';

import { Container, appearFromLeft } from '../../styles';

export const InitialContainer = styled(Container)`
  animation: ${appearFromLeft} 1s;

  img {
    flex: 1;
  }
`;

export const ContentWrapper = styled.section`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-direction: column;

  h3 {
    font-weight: 500;
    font-size: 24px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #475466;
  }

  p {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #98a2b3;
  }
`;

export const CreateApprovalButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  background: #4a90e2;
  border-radius: 50px;
  width: 320px;
  border: 0;
  color: #ffffff;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  padding: 13px;
  margin-top: 5px;

  &:hover {
    background: ${shade(0.05, '#4a90e2')};
    color: ${shade(0.05, '#ffffff')};
  }
`;
